import React from 'react';

const SeraloginOnlineContainer = ({ children }) => {
  const containerStyle = {
    backgroundColor: '#E9E9FD',
    borderRadius: '18px',
    padding: '18px',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '12px',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    flexWrap: 'wrap'
  };

  return <div style={containerStyle}>{children}</div>;
};

export default SeraloginOnlineContainer;